export enum FloridaLoadDescription {
  constructionOrIndustrial = 'constructionOrIndustrial',
  portableBuilding = 'portableBuilding',
  farmEquipment = 'farmEquipment',
  earthHandlingEquipment = 'earthHandlingEquipment',
  noneOfTheAbove = 'noneOfTheAbove',
}

export const FloridaLoadDescriptionValues = Object.values(
  FloridaLoadDescription,
);
